import * as React from 'react'

function SvgFunArrowUp(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M19 17a.997.997 0 01-.707-.293L12 10.414l-6.293 6.293a.999.999 0 11-1.414-1.414l7-7a.999.999 0 011.414 0l7 7A.999.999 0 0119 17" />
    </svg>
  )
}

export default SvgFunArrowUp
